import { observer } from "mobx-react-lite";
import React from "react";
import { Link } from "react-router-dom";
import { useShopInfoStore } from "../../store";
import { Popover } from "antd";
import classNames from "classnames";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import CountValue from "../../CountValue";

interface ShipAreaProps {}

const ShipArea: React.FC<ShipAreaProps> = function (props) {
    const store = useShopInfoStore();

    const yesterdayOrderCount = store.getCount(store.yesterdayOrderCount);
    const yesterdayItemCount = store.getCount(store.yesterdayItemCount);
    const yesterdayWaybillCount = store.getCount(store.yesterdayWaybillCount);

    const yesterdayOrderCountEl = (
        <div className={classNames("count", yesterdayOrderCount === store.NoStatistics && "error")}>
            <CountValue value={yesterdayOrderCount} />
        </div>
    );
    const yesterdayItemCountEl = (
        <div className={classNames("count", yesterdayItemCount === store.NoStatistics && "error")}>
            <CountValue value={yesterdayItemCount} />
        </div>
    );
    const yesterdayWaybillCountEl = (
        <div className={classNames("count", yesterdayWaybillCount === store.NoStatistics && "error")}>
            <CountValue value={yesterdayWaybillCount} />
        </div>
    );

    return (
        <div className="ship-area">
            <div className="ship-area-item">
                <Popover content="已开启发货统计的店铺，昨日发货订单数(包含发货后退款，取消订单)" placement="topLeft">
                    <div className="title">昨日发货订单</div>
                </Popover>

                {yesterdayItemCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>昨日无发货统计数据，如要查看数据可前往开启</span>
                                <Link to="/features/shipmentStatistics" className="ml5">
                                    去开启
                                </Link>
                            </div>
                        }
                    >
                        {yesterdayOrderCountEl}
                    </Popover>
                ) : (
                    yesterdayOrderCountEl
                )}
            </div>
            <div className="ship-area-item">
                <Popover content="已开启发货统计的店铺，昨日发货商品数(包含发货后退款，取消商品)" placement="topLeft">
                    <div className="title">昨日发货商品</div>
                </Popover>

                {yesterdayItemCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>昨日无发货统计数据，如要查看数据可前往开启</span>
                                <Link to="/features/shipmentStatistics" className="ml5">
                                    去开启
                                </Link>
                            </div>
                        }
                    >
                        {yesterdayItemCountEl}
                    </Popover>
                ) : (
                    yesterdayItemCountEl
                )}
            </div>
            <div className="ship-area-item">
                <Popover content="已开启发货统计的店铺，昨日发货的运单号数(仅软件内发货)" placement="topLeft">
                    <div className="title">昨日发货单号</div>
                </Popover>

                {yesterdayItemCount === store.NoStatistics ? (
                    <Popover
                        content={
                            <div>
                                <span>昨日无发货统计数据，如要查看数据可前往开启</span>
                                <Link to="/features/shipmentStatistics" className="ml5">
                                    去开启
                                </Link>
                            </div>
                        }
                    >
                        {yesterdayWaybillCountEl}
                    </Popover>
                ) : (
                    yesterdayWaybillCountEl
                )}
            </div>

            <Link
                to="/features/shipmentStatistics?fromHome=1"
                className="operation"
                onClick={() => {
                    collectEvent(DataTrackEvent.CLICK_HOME_CONTENT, {
                        content: "查看发货统计",
                    });
                }}
            >
                查看发货统计
            </Link>
        </div>
    );
};

export default observer(ShipArea);
